import {observable, action} from 'mobx';
import {async} from '../../server-wait';
import {nonenumerable, writable, autobind} from 'spa/decorators';
import QS from 'qs';
import deepEqual from 'deep-equal';

import makeAbortable from 'abortable-promise';

const errorHandler = (error) => {
  // noop
  if (__DEV__) {
    console.error(error);
  }
};

class APIRequestState {
  // method = 'GET';
  // url = '/';

  @observable isLoading = false;
  @observable response = null;
  @observable error = null;
  params = null;
  @nonenumerable @writable promise;
  @nonenumerable @writable lastLoad;
  @nonenumerable @writable promise;

  getRequest(urlParams, ...params) {
    if (!this.method) {
      throw new Error('Missing option `method`');
    }
    if (!this.url) {
      throw new Error('Missing option `url`');
    }
    return this.ctx.sdk[this.method.toLowerCase()](`${this.url}?${QS.stringify(urlParams)}`, ...params);
  }

  putRequest(urlId, ...params) {
    // urlId might not be present for /me routes
    const urlSuffix = urlId ? `${urlId}/` : '';

    if (!this.method) {
      throw new Error('Missing option `method`');
    }
    if (!this.url) {
      throw new Error('Missing option `url`');
    }
    return this.ctx.sdk[this.method.toLowerCase()](`${this.url}/${urlSuffix}`, ...params);
  }

  abort() { if (this._abort) this._abort(); }

  @action maybeLoad(...params) {
    if (this.response || this.isLoading) {
      if (deepEqual(this.params, ...params)) {
        return this.lastLoad;
      }
    }
    return this.load(...params);
  }

  @async @action load(...params) {
    this.abort();

    this.isLoading = true;
    this.error = null;
    this.params = params;

    const {promise, abort} = makeAbortable(this.getRequest(...params));

    this.promise = promise;
    this._abort = abort;

    this.lastLoad = promise
      .then(this.onSuccess, this.onFailure);

    this.lastLoad.then(null, errorHandler); // stop unhandled rejection warnings

    return this.lastLoad;
  }

  @async @action put(...params) {
    this.abort();

    this.isLoading = true;
    this.error = null;
    this.params = params;

    const {promise, abort} = makeAbortable(this.putRequest(...params));

    this.promise = promise;
    this._abort = abort;

    this.lastLoad = promise
      .then(this.onSuccess, this.onFailure);

    this.lastLoad.then(null, errorHandler); // stop unhandled rejection warnings

    return this.lastLoad;
  }

  @async @action delete(...params) {
    this.abort();

    this.isLoading = true;
    this.error = null;
    this.params = params;

    const {promise, abort} = makeAbortable(this.putRequest(...params));

    this.promise = promise;
    this._abort = abort;

    this.lastLoad = promise
      .then(this.onSuccess, this.onFailure);

    this.lastLoad.then(null, errorHandler); // stop unhandled rejection warnings

    return this.lastLoad;
  }

  @autobind @action onSuccess({response, json}) {
    this.isLoading = false;
    return (this.response = json); //eslint-disable-line no-return-assign
  }
  @autobind @action onFailure(error) {
    this.isLoading = false;
    this.error = error;
    this.response = null;
    this.params = null;
    throw error;
  }

  @autobind @action reset() {
    this.abort();
    this.isLoading = false;
    this.response = null;
    this.params = null;
    this.error = null;
    this.lastLoad = null;
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }
}

export default APIRequestState;



// WEBPACK FOOTER //
// ./spa/state/_util/api-request.jsx